import {NgClass} from '@angular/common';
import {Component, Input} from '@angular/core';
import {TBankRequestStatus} from './bank-request.interface';

@Component({
  selector: 'app-bank-request-status-badge',
  standalone: true,
  imports: [NgClass],
  template: `
    <span class="badge rounded-pill status-pill" [ngClass]="statusClass">
      {{ statusLabel }}
    </span>
  `,
})
export class BankRequestStatusBadgeComponent {
  @Input() status: TBankRequestStatus;

  get statusLabel(): string {
    switch (this.status) {
      case 'SUBMITTED':
        return 'Submitted';
      case 'IN_REVIEW':
        return 'In review';
      case 'IN_PROGRESS':
        return 'In progress';
      case 'COMPLETED':
        return 'Completed';
      case 'DECLINED':
        return 'Declined';
      default:
        return this.status;
    }
  }

  get statusClass(): string {
    switch (this.status) {
      case 'IN_REVIEW':
        return 'text-bg-warning-light';
      case 'IN_PROGRESS':
        return 'text-bg-primary';
      case 'COMPLETED':
        return 'text-bg-success-light-2';
      case 'DECLINED':
        return 'text-bg-danger-light';
      case 'SUBMITTED':
      default:
        return 'text-bg-info-light';
    }
  }
}
